import React, { useEffect, useState } from "react";
import client from "../contenful/client"; // adjust if path is different
import Tittle from "../components/Tittle";
import Card2 from "../components/Card2";
import Nav from '../components/Nav';
import aboutlogo from '../images/aboutLogo.png';
import ScrollEffect from "../components/ScrollEffect";
import './Media.css';
import Footer from "../components/Footer";

const Media = () => {
  const [mediaCards, setMediaCards] = useState([]);
  const [mediaDescription, setMediaDescription] = useState("");

  useEffect(() => {
    const fetchMedia = async () => {
      try {
        const res = await client.getEntries({
          content_type: "media", // 👈 replace with your actual content type ID
        });
        console.log("Fetched Contentful Entries:", res);
        setMediaCards(res.items);

        

        if (res.items.length > 0) {
          const item = res.items[0];    
           //description field

           setMediaDescription(item.fields.mediaParagraph || "");
          const media = item.fields.mediaPageCard?.map((card, index) => ({
            image: card?.fields?.file?.url || "",
            title: item.fields.mediaPageTittle?.[index]?.fields?.file?.url || "",
            description: card?.fields?.description || "No Description",
          }));

          setMediaCards(media || []);
        }
      } catch (error) {
        console.error("Error fetching Media data:", error);
      }
    };

    fetchMedia();
  }, []);

  return (
    <>
    <Nav logo={aboutlogo} hamburgerColor='black' logoSize="300px" className="static-nav" />
    <div className="media-sec">
      <div className="media-page-desc">
        <p>
          {mediaDescription}
        </p>
      </div>
      <div className="media services">
        <ScrollEffect fadeType="fade-up">
          <div className="media-cards">
            {mediaCards?.map((card, index) => (
              <Card2
                key={index}
                image={card.image}
                image2={card.title}
                desc={card.description}
                isProject={true}
              />
            ))}
          </div>
        </ScrollEffect>
      </div>
    </div>
    <Footer/>
    </>
   
  );
};

export default Media;
